/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {startTimecard} from '../api'

export const useMutationStartTimecard = createReactQueryMutationHook('startTimecard', startTimecard)
